import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardConsole } from "@/lib/route-guard";

export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: guardConsole("admin"),
  component: () => <Outlet />,
});
